import { forwardRef, type TextareaHTMLAttributes } from 'react';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, hint, className = '', id, ...props }, ref) => {
    const textareaId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={textareaId}
            className="mb-1 block text-[13px] font-medium text-[#666]"
          >
            {label}
            {props.required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={`
            w-full min-h-[120px] resize-y rounded-2xl border bg-white px-4 py-3 text-[14px] text-[#1A1A1A] transition-all duration-200
            focus:border-copper focus:ring-2 focus:ring-copper/20 focus:outline-none
            disabled:cursor-not-allowed disabled:bg-[#F5F2ED]
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : 'border-[#DEDBD6]'}
            ${className}
          `}
          {...props}
        />
        {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
        {hint && !error && <p className="mt-1 text-xs text-[#999]">{hint}</p>}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
